export default __webpack_public_path__ + "static/media/logo.7d68e2ac.jpg";